import { Configuration, LogLevel } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_AD_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_AD_TENANT_ID || 'common'}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    // localStorage: Anmeldung bleibt über Tab-/Browser-Neustart erhalten
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (import.meta.env.DEV) {
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              break;
            case LogLevel.Warning:
              console.warn(message);
              break;
          }
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: [
    `api://${import.meta.env.VITE_AZURE_AD_CLIENT_ID}/user_impersonation`,
    'openid',
    'profile',
    'email',
  ],
};

export const tokenRequest = {
  scopes: [`api://${import.meta.env.VITE_AZURE_AD_CLIENT_ID}/user_impersonation`],
};

export const graphUserSearchRequest = {
  scopes: ['https://graph.microsoft.com/User.Read.All'],
};
